/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stale_Royal_Thrush_ReadInputs */

const fr_stale_royal_thrush_read = /** @type {(inputs: Stale_Royal_Thrush_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

/**

* @param {Stale_Royal_Thrush_ReadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stale_royal_thrush_read = /** @type {((inputs?: Stale_Royal_Thrush_ReadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stale_Royal_Thrush_ReadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stale_royal_thrush_read(inputs)
});